// extracted by mini-css-extract-plugin
module.exports = {"root":"Bind_root__3D1QW","small":"Bind_small__3_LqR"};